module.exports = __webpack_public_path__ + "/images/ico-vendedores-red.0e1c294.svg";